import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "form-group mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relatedness", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "ms-1"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary" }, null, -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "input-group date datepickerInput" }
const _hoisted_24 = ["value", "disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "input-group date datepickerInput" }
const _hoisted_31 = ["value", "disabled"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_33 = {
  key: 2,
  class: "text-end"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 3,
  class: "button-cell text-end"
}
const _hoisted_39 = { colspan: "3" }
const _hoisted_40 = {
  key: 0,
  class: "row-no-hover edit-row"
}
const _hoisted_41 = ["colspan"]
const _hoisted_42 = { class: "d-flex flex-column align-items-center" }
const _hoisted_43 = { class: "form-group w-50" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "not-related-reason" }, [
  /*#__PURE__*/_createTextVNode("Reason"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass({ 'edit-row': _ctx.isEditRequested })
    }, [
      _createElementVNode("td", null, _toDisplayString(_ctx.supply.name), 1 /* TEXT */),
      _createElementVNode("td", null, _toDisplayString(_ctx.supply.unitCost), 1 /* TEXT */),
      _createElementVNode("td", null, [
        (_ctx.supply.isFormulary === true)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Yes"))
          : _createCommentVNode("v-if", true),
        (_ctx.supply.isFormulary === false)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "No"))
          : _createCommentVNode("v-if", true),
        (!_ctx.isSupplyFormularyBoolean)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, _hoisted_5))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.isEditRequested)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                class: "form-select",
                name: "related-diag",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.supply.isRelated) = $event))
              }, _hoisted_10, 512 /* NEED_PATCH */)), [
                [_vModelSelect, _ctx.supply.isRelated]
              ])
            : _createCommentVNode("v-if", true)
        ]),
        (!_ctx.isEditRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (!_ctx.isSupplyIsRelatedBoolean)
                ? (_openBlock(), _createElementBlock("small", _hoisted_12, _hoisted_14))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.supply.isRelated ? "Yes" : "No"), 1 /* TEXT */)),
              (_ctx.supply.isRelated === false)
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_18)), [
                    [_directive_tooltip, { title: _ctx.supply.notRelatedComments }]
                  ])
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
            (!_ctx.isEditRequested)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  (_ctx.supply.startDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.supply.startDate)), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, " - "))
                ]))
              : (_openBlock(), _createBlock(_component_DatePicker, {
                  key: 1,
                  getDate: _ctx.onDateChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("input", {
                        name: "supplyStartDate",
                        type: "text",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.supply.startDate.$error ? '' : 'field-invalid'}`]),
                        value: _ctx.formatDateInput(_ctx.supply.startDate),
                        placeholder: "MM/DD/YYYY",
                        "date-format-only": "",
                        disabled: !_ctx.isEditAllowed,
                        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.supply.startDate.$touch && _ctx.v$.supply.startDate.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_24),
                      _hoisted_25
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"]))
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
            (!_ctx.isEditRequested)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                  (_ctx.supply.endDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.formatDate(_ctx.supply.endDate)), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_29, " - "))
                ]))
              : (_openBlock(), _createBlock(_component_DatePicker, {
                  key: 1,
                  getDate: _ctx.onDateChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("input", {
                        name: "supplyEndDate",
                        type: "text",
                        class: "form-control",
                        value: _ctx.formatDateInput(_ctx.supply.endDate),
                        placeholder: "MM/DD/YYYY",
                        "date-format-only": "",
                        disabled: !_ctx.isEditAllowed
                      }, null, 8 /* PROPS */, _hoisted_31),
                      _hoisted_32
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"]))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" ACTIONS "),
      (!_ctx.isEditRequested && !_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-info",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editSupply()))
            }, _hoisted_35),
            (!_ctx.supply.id && _ctx.isEditAllowed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn table-btn btn-outline-danger",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.requestDeleteSupply()))
                }, _hoisted_37))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" EDIT "),
      (_ctx.isEditRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-success",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveEdit()))
            }, "Save"),
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelEdit()))
            }, "Cancel")
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" DELETE "),
      _withDirectives(_createElementVNode("td", _hoisted_39, [
        _createVNode(_component_TablePrompt, {
          message: `Are you sure want to delete ${_ctx.supply.name}?`,
          "ok-text": "delete",
          name: "Delete",
          ok: _ctx.deleteSupply,
          cancel: _ctx.cancelDelete
        }, null, 8 /* PROPS */, ["message", "ok", "cancel"])
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.isDeleteRequested]
      ])
    ], 2 /* CLASS */),
    (_ctx.isEditRequested && _ctx.supply.isRelated === false)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-2 edit"
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_CommentInput, {
                  "input-name": "not-related-comments",
                  result: _ctx.supply.notRelatedComments,
                  placeholder: "Specify rationale and pertinent medical management information.",
                  "max-length": "2000",
                  onResultUpdatedAppended: _ctx.resultUpdatedAppended,
                  onResultUpdated: _ctx.resultUpdated
                }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated"])
              ])
            ])
          ], 8 /* PROPS */, _hoisted_41)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}